import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
export default function Home() {
  const technologies = [
    { name: 'React JS', icon: '⚛️' },
    { name: 'React Native', icon: '📱' },
    { name: 'Angular', icon: '🅰️' },
    { name: 'Vue JS', icon: '🟢' },
    { name: 'Node JS', icon: '🟩' },
    { name: 'Laravel', icon: '🔺' },
    { name: 'Python', icon: '🐍' },
    { name: 'PHP', icon: '🐘' },
    { name: 'Flutter', icon: '🦋' },
    { name: 'Firebase', icon: '🔥' },
    { name: 'MongoDB', icon: '🍃' },
    { name: 'MySQL', icon: '🗄️' },
    { name: 'SQL Server', icon: '💾' },
    { name: '.NET', icon: '🟣' },
    { name: 'Tailwind CSS', icon: '💨' },
    { name: 'AWS', icon: '☁️' },
    { name: 'Docker', icon: '🐳' },
    { name: 'GitHub', icon: '🐙' }
  ];

  const industries = [
    { name: 'eCommerce B2B', icon: '🏢' },
    { name: 'eCommerce B2C', icon: '🛒' },
    { name: 'Textiles', icon: '🧵' },
    { name: 'Marketing Agencies', icon: '📢' },
    { name: 'Matrimonial Services', icon: '💍' },
    { name: 'Transport & Logistics', icon: '🚚' },
    { name: 'Members Organizations', icon: '👥' },
    { name: 'Finance Services', icon: '💰' },
    { name: 'Retail Shops', icon: '🏬' },
    { name: 'Jewellery Stores', icon: '💎' },
    { name: 'Hospitals', icon: '🏥' },
    { name: 'Schools & Colleges', icon: '🎓' },
    { name: 'Restaurants', icon: '🍽️' },
    { name: 'Manufacturing Industries', icon: '🏭' },
    { name: 'Real Estate', icon: '🏠' },
    { name: 'Startups', icon: '🚀' }
  ];

  const recentWorks = [
    {
      name: 'Kongu Mangai',
      url: 'https://kongumangai.com'
    },
    {
      name: 'Create Learning',
      url: 'https://www.createlearning.in'
    },
    {
      name: 'GJ Jewellery',
      url: 'https://play.google.com/store/apps/details?id=com.gjjewellery'
    },
    {
      name: 'Regular Solution',
      url: 'https://play.google.com/store/apps/details?id=com.regularsolutionsuser'
    },
    {
      name: 'Senthanamuthan Kids Wear',
      url: 'https://senthanamuthankidswear.shop'
    }
  ];

  const feedbacks = [
    {
      name: 'Kongu Mangai',
      role: 'Matrimonial Platform',
      feedback: 'Professional website development service with excellent support and modern design.'
    },
    {
      name: 'Create Learning',
      role: 'Educational Platform',
      feedback: 'Excellent educational platform with modern UI and smooth performance.'
    },
    {
      name: 'GJ Jewellery',
      role: 'Jewellery Business',
      feedback: 'Outstanding ecommerce website and customer support service.'
    }
  ];

  return (
    <div>
      <Helmet>
        <title>Praneesh Infotech | Website Development Company in Erode</title>
        <meta
          name="description"
          content="Praneesh Infotech provides website development, mobile app development, ecommerce solutions, ERP software, digital marketing, CRM, and custom software development services in Erode, Tamil Nadu."
        />

        <meta
          name="keywords"
          content="Website Development Company Erode, Mobile App Development Erode, ERP Software Company Tamil Nadu, Ecommerce Website Development, Matrimonial Website Development, React JS Development, Digital Marketing Company Erode, CRM Software Development, Billing Software, Custom Software Development, SEO Services, Laravel Development, React Native Development, Software Company in Erode, Praneesh Infotech"
        />
      </Helmet>
      <section className="bg-gradient-to-r from-[#0a8082] to-[#0b5f60] text-white py-28 px-6 text-center min-h-[85vh] flex items-center">
        <div className="max-w-6xl mx-auto">
          <p className="uppercase tracking-[4px] text-yellow-300 mb-4 font-semibold">
            Welcome To Praneesh Infotech
          </p>

          <h1 className="text-5xl md:text-7xl font-extrabold leading-tight mb-8">
            Transform Your Business With Smart Digital Solutions
          </h1>

          <p className="text-xl leading-9 max-w-4xl mx-auto text-gray-100 mb-10">
            Website development, mobile applications, billing software and custom business solutions.
          </p>

          <div className="flex flex-wrap justify-center gap-5">
            <Link
              to="/contact"
              className="bg-white text-[#0a8082] px-10 py-4 rounded-full font-bold hover:scale-105 hover:shadow-2xl transition duration-300 inline-flex items-center gap-3"
            >
              Get Started 🚀
            </Link>

            <Link
              to="/services"
              className="border border-white px-10 py-4 rounded-full font-bold hover:bg-white hover:text-[#0a8082] hover:shadow-2xl transition duration-300 inline-flex items-center gap-3"
            >
              View Services 💼
            </Link>
          </div>
        </div>
      </section>

      <section className="py-24 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto mb-24">
          <div className="text-center mb-14">
            <p className="uppercase tracking-[3px] text-[#0a8082] font-semibold mb-3">
              Why Choose Us
            </p>

            <h2 className="text-5xl font-bold">
              Why Choose Praneesh Infotech
            </h2>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                title: 'Experienced Team',
                icon: '👨‍💻',
                description: 'Skilled professionals delivering innovative digital solutions.'
              },
              {
                title: 'Affordable Pricing',
                icon: '💰',
                description: 'Cost-effective services designed for startups and enterprises.'
              },
              {
                title: 'Latest Technologies',
                icon: '🚀',
                description: 'Modern frameworks and cutting-edge technologies.'
              },
              {
                title: 'Customer Support',
                icon: '🎧',
                description: 'Reliable customer assistance and technical support anytime.'
              },
              {
                title: 'Responsive Design',
                icon: '📱',
                description: 'Fully responsive websites and applications.'
              },
              {
                title: 'SEO Friendly',
                icon: '📈',
                description: 'Optimized websites for better online visibility.'
              },
              {
                title: 'Custom Solutions',
                icon: '⚙️',
                description: 'Tailor-made software solutions for your business.'
              },
              {
                title: 'On-Time Delivery',
                icon: '⏰',
                description: 'Projects delivered within deadlines with quality.'
              }
            ].map((item, index) => (
              <div
                key={index}
                className="bg-white border border-gray-100 rounded-3xl p-8 shadow-lg hover:-translate-y-3 hover:shadow-2xl transition duration-300 group text-center"
              >
                <div className="w-20 h-20 rounded-2xl bg-gradient-to-r from-[#0a8082] to-[#071E56] text-white flex items-center justify-center text-4xl mx-auto mb-6 group-hover:scale-110 transition duration-300">
                  {item.icon}
                </div>

                <h3 className="text-2xl font-bold text-[#071E56] mb-4">
                  {item.title}
                </h3>

                <p className="text-gray-600 leading-8 text-lg">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="max-w-7xl mx-auto mb-24">
          <div className="text-center mb-14">
            <h2 className="text-5xl font-bold">Technologies We Use</h2>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            {technologies.map((tech, index) => (
              <div
                key={index}
                className="bg-white border border-gray-100 rounded-3xl p-6 shadow-lg text-center hover:-translate-y-3 hover:shadow-2xl transition duration-300 group"
              >
                <div className="w-10 h-10 rounded-2xl text-white flex items-center justify-center text-4xl mx-auto mb-5 group-hover:scale-110 transition duration-300">
                  {tech.icon}
                </div>

                <h3 className="text-lg font-bold text-[#071E56] leading-7">
                  {tech.name}
                </h3>
              </div>
            ))}
          </div>
        </div>

        <div className="max-w-7xl mx-auto mb-24">
          <div className="text-center mb-14">
            <h2 className="text-5xl font-bold">Industries We Work With</h2>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {industries.map((industry, index) => (
              <div
                key={index}
                className="bg-white border border-gray-100 rounded-3xl p-8 shadow-lg text-center hover:-translate-y-3 hover:shadow-2xl transition duration-300 group"
              >
                <div className="w-20 h-20 rounded-2xl bg-gradient-to-r from-[#0a8082] to-[#071E56] text-white flex items-center justify-center text-4xl mx-auto mb-6 group-hover:scale-110 transition duration-300">
                  {industry.icon}
                </div>

                <h3 className="text-xl font-bold text-[#071E56] leading-8">
                  {industry.name}
                </h3>
              </div>
            ))}
          </div>
        </div>

        <div className="max-w-7xl mx-auto mb-24">
          <div className="text-center mb-14">
            <h2 className="text-5xl font-bold">Our Recent Works</h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
            {recentWorks.map((work, index) => (
              <a
                key={index}
                href={work.url}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white border rounded-3xl p-6 shadow-lg text-center hover:-translate-y-2 hover:shadow-2xl transition duration-300 block"
              >
                <div className="text-5xl mb-5">🤝</div>

                <h3 className="text-lg font-bold text-[#071E56] mb-3">
                  {work.name}
                </h3>

                <a
                  href={work.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-[#0a8082] to-[#071E56] text-white px-5 py-3 rounded-full font-semibold hover:scale-105 transition duration-300 shadow-lg"
                >
                  Visit the Link
                </a>
              </a>
            ))}
          </div>
        </div>

        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14">
            <h2 className="text-5xl font-bold">What Our Clients Say</h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {feedbacks.map((review, index) => (
              <div
                key={index}
                className="bg-white rounded-3xl p-8 shadow-xl border hover:-translate-y-2 transition duration-300"
              >
                <div className="text-yellow-400 text-2xl mb-5">
                  ★★★★★
                </div>

                <p className="text-gray-600 leading-8 text-lg mb-8 italic">
                  “{review.feedback}”
                </p>

                <h3 className="text-2xl font-bold text-[#071E56] mb-2">
                  {review.name}
                </h3>

                <p className="text-gray-500 font-medium">
                  {review.role}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}